import type { RouteObject } from "react-router";

/** Under /t/:chain/:token (lazy, see overview_tape/routes). */
export const tokenLiquidityRoutes: RouteObject[] = [
  // `:tab` is book, history or lps (lib/charts/lpLayout TABS); without it, the token's default tab
  { path: "liquidity/:tab?", lazy: async () => ({ Component: (await import("./LiquidityView")).default }) },
];

/** Top-level routes owned by the liquidity_hooks_signals slice. */
export const chainAndGlobalRoutes: RouteObject[] = [
  { path: "liquidity/:chain", lazy: async () => ({ Component: (await import("./LedgersView")).default }) },
  {
    path: "liquidity/:chain/ledger/:contract",
    lazy: async () => ({ Component: (await import("./LedgerView")).default }),
  },
  { path: "hooks/:chain", lazy: async () => ({ Component: (await import("./HooksView")).default }) },
  {
    path: "hooks/:chain/hook/:hook",
    lazy: async () => ({ Component: (await import("./HookView")).default }),
  },
  { path: "signals", lazy: async () => ({ Component: (await import("./SignalsView")).default }) },
  { path: "health", lazy: async () => ({ Component: (await import("./HealthView")).default }) },
];
